const SearchResults = () => {
//check if page is search results page (id 360)
  if (document.querySelector('.page.page-id-360')) {

    let selectedProduct = null;
    let selectedKeywords = [];
    let documentData = null;
    let publicationData = null;
    let productData = null;

    try {
      //get and decode query string
      const queryString = decodeURI(window.location.search);
      //get query string parameters
      const urlParams = new URLSearchParams(queryString);

      //get product parameter
      selectedProduct = urlParams.get('p');

      //get keywords parameter
      const keywords = urlParams.get('k');
      //split keywords into array
      selectedKeywords = keywords.toLowerCase().split('|');
    } catch (e) {
      console.log('ERROR! L25');
      console.log(e);
    }

    //get product data
    if (sessionStorage.getItem('productData') === null) {
      //if data is not in session storage, get from API
      fetch('/api/mira/v1/products')
        .then(response => response.json())
        .then(data => {
          productData = data;
          sessionStorage.setItem('productData', JSON.stringify(data));
        });
    } else {
      //get data from session storage
      productData = JSON.parse(sessionStorage.getItem('productData'));
    }

    //get document data
    if (sessionStorage.getItem('srlData') === null) {
      //if data is not in session storage, get from API
      fetch('/api/mira/v1/srls')
        .then(response => response.text())
        .then(data => {
          //if ends with 1, remove last character
          if (data.endsWith('1')) {
            data = data.slice(0, -1);
          }

          console.log('FETCH /api/mira/v1/srls');
          console.log(data);
          sessionStorage.setItem('srlData', data);

          documentData = JSON.parse(data);
          setTimeout(() => {
            renderDocuments().then(() => {
              //update documents count (minus 1 for title element row)
              try {
                const count = document.querySelector('[data-subj="docs"]').childElementCount - 1;
                document.querySelector('[data-obj="doc-count"]').innerHTML = count.toString();
                checkEmptyResults();
              } catch (e) {
                console.log('ERROR! L64');
                console.log(e);
              }
            });
          }, 500);
        });
    } else {
      //get data from session storage
      documentData = JSON.parse(sessionStorage.getItem('srlData'));
      renderDocuments().then(() => {
        //update documents count (minus 1 for title element row)
        try {
          const count = document.querySelector('[data-subj="docs"]').childElementCount - 1;
          document.querySelector('[data-obj="doc-count"]').innerHTML = count.toString();
          checkEmptyResults();
        } catch (e) {
          console.log('ERROR! L79');
          console.log(e);
        }
      });
    }

    //get publication data
    if (sessionStorage.getItem('publicationData') === null) {
      //if data is not in session storage, get from API
      fetch('/api/mira/v1/publications')
        .then(response => response.json())
        .then(data => {
          publicationData = data;

          sessionStorage.setItem('publicationData', JSON.stringify(data));

          setTimeout(() => {
            renderPublications().then(() => {
              //update publications count (minus 1 for title element row)
              try {
                const count = document.querySelector('[data-subj="pubs"]').childElementCount - 1;
                document.querySelector('[data-obj="pub-count"]').innerHTML = count.toString();
                checkEmptyResults();
              } catch (e) {
                console.log('ERROR! L102');
                console.log(e);
              }
            });
          }, 500);
        });
    } else {
      //get data from session storage
      publicationData = JSON.parse(sessionStorage.getItem('publicationData'));
      renderPublications().then(() => {
        //update publications count (minus 1 for title element row)
        try {
          const count = document.querySelector('[data-subj="pubs"]').childElementCount - 1;
          document.querySelector('[data-obj="pub-count"]').innerHTML = count.toString();
          checkEmptyResults();
        } catch (e) {
          console.log('ERROR! L117');
          console.log(e);
        }
      });
    }

    /*
    Event Listeners
    */

    //modal/interstitial links
    document.querySelectorAll('a[data-modal]').forEach(el => {

      let modalName = el.getAttribute('data-modal');
      let destURL = el.getAttribute('href');
      let modalObj = document.querySelector(`.${modalName}`);
      let modalFade = document.querySelector('.modal-backdrop');

      if (modalObj) {
        el.addEventListener('click', function (ev) {
          ev.preventDefault();

          if (!modalFade) {
            document.body.insertAdjacentHTML('beforeend', '<div class="modal-backdrop fade d-none"></div>');
            modalFade = document.querySelector('.modal-backdrop');
          }

          modalFade.classList.add('d-block');
          modalFade.classList.remove('d-none');

          modalObj.setAttribute('data-dest', destURL);
          modalObj.classList.add('show');
          modalObj.style.display = 'block';
        });

        if (modalObj.getAttribute('data-init') !== 'yes') {
          modalObj.setAttribute('data-init', 'yes');

          modalObj.querySelector('.btn-close').addEventListener(
            'click',
            function(ev) {
              modalFade.classList.remove('d-block');
              modalFade.classList.add('d-none');

              modalObj.classList.remove('show');
              modalObj.style.display = 'none';
              modalObj.querySelector('.spinner-border').classList.add('d-none');
              modalObj.querySelector('.spinner-border').classList.remove('d-block');
            }
          );

          modalObj.querySelector('.btn.btn-primary').addEventListener(
            'click',
            function(ev) {
              this.disabled = true;

              modalObj.querySelector('.btn-close').disabled = true;
              modalObj.querySelector('.spinner-border').classList.add('d-block');
              modalObj.querySelector('.spinner-border').classList.remove('d-none');

              window.location.href = modalObj.getAttribute('data-dest');
            }
          );
        }
      }
    });

    //dropdown item selected
    document.querySelectorAll('ul.dropdown-menu li').forEach(el => {
      el.addEventListener('click', function () {
        //get data-option value and set as selectedProduct
        selectedProduct = el.getAttribute('data-option').toLowerCase();
        //set dropdown button text
        document.querySelector('.dropdown-toggle span').innerHTML = el.innerHTML;
      });
    });

    //search button pressed
    document.querySelector('#search-button').addEventListener('click', () => searchButton());

    //keyword input enter pressed
    document.querySelector('#keyword-input').addEventListener('keypress', e => {
      if (e.key === 'Enter') {
        e.preventDefault();
        searchButton();
      }
    });

    //NPI modal close button pressed
    document.querySelectorAll('[data-widget="modal-npi"] [data-action="exit"]').forEach(el => {
      el.addEventListener('click', () => {
        document.querySelector('[data-widget="modal-npi"]').style.display = 'none';
      });
    });

    //NPI modal unlock button pressed
    document.querySelector('#button-npi').addEventListener('click', () => downloadFile());

    //NPI modal NPI input enter pressed
    document.querySelector('#npi-input').addEventListener('keypress', e => {
      if (e.key === 'Enter') {
        downloadFile();
      }
    });


    /*
    Functions
    */

    function searchButton() {
      //navigate to search results page with query string
      const keywordBox = document.querySelector(`#keyword-input`);

      //commma separated keywords to |
      let keywords = keywordBox.value.split(',').join('|');
      //remove spaces before and after |
      keywords = keywords.replace(/\s*\|\s*/g, '|');
      //trim trailing spaces
      keywords = keywords.replace(/\s+$/, '');

      //add to query string
      const queryString = `?p=${selectedProduct}&k=${keywords}`;

      //encode query string
      const encodedQueryString = encodeURI(queryString);

      if (keywordBox.value !== "") {
        window.location.href = `/results/${encodedQueryString}`;
      } else {
        //TODO: show error message
      }
    }

    function downloadFile() {
      //download file from NPI modal

      const modal = document.querySelector('[data-widget="modal-npi"]');
      const docId = document.querySelector('#button-npi').getAttribute('data-doc-id');
      const docFilename = document.querySelector('#button-npi').getAttribute('data-filename');
      const docTitle = document.querySelector('#button-npi').getAttribute('data-doc-title');
      const docNumber = document.querySelector('#button-npi').getAttribute('data-doc-number');
      const majorDocVersion = document.querySelector('#button-npi').getAttribute('data-v-major');
      const minorDocVersion = document.querySelector('#button-npi').getAttribute('data-v-minor');
      const npiNumber = document.querySelector('#npi-input').value;
      const status = modal.querySelector('[data-status]');

      if (npiNumber.length === 10) {
        //if npi number is correct, unlock document
        sessionStorage.setItem('npiNumber', npiNumber);

        fetch(`/api/mira/v1/download-srl/veeva_doc_id=${docId}/npi=${npiNumber}/v_major=${majorDocVersion}/v_minor=${minorDocVersion}`)
          .then(response => response.blob())
          .then(blob => {
            if (blob.size === 0) {
              //show error message
              const errorText = document.createElement('p');
              errorText.setAttribute('style', 'font-size: 13px; font-weight: 500; margin-top: 10px; font-style: italic; color: #DB0000;');
              errorText.innerHTML = "NPI number is incorrect";
              modal.querySelector('form').appendChild(errorText);
              return;
            }
            const downloadUrl = URL.createObjectURL(blob);
            const a = modal.querySelector('#view-document');
            a.href = downloadUrl;
            a.download = docFilename;
            status.setAttribute('data-status', 'unlocked');
            logSRLClick(docId, npiNumber, docNumber, docTitle);
          }).catch(e => {
          //if error, show error message
        })
      } else {
        //length is incorrect, show error message
      }
    }

    function renderDocuments() {
      return new Promise((resolve, reject) => {
        //render publications array using filters

        if (documentData && documentData.forEach) {
          documentData.forEach(document => {
            //if document is not marked as "Approved for Use", skip
            if (document.status__v !== "Approved for Use") return;

            let productMatch = false, keywordMatch = false;

            //check if publication matches selected product
            try {
              productData.forEach(product => {
                if (product.veeva_id === document.product__v[0]) {
                  if (product.name.toLowerCase() === selectedProduct) {
                    productMatch = true;
                  }
                }
              });
            } catch (e) {
              console.log('ERROR! L256');
              console.log(e);
            }

            //check if publication keywords match selected keywords
            try {
              document.tags__v.forEach(keyword => {
                if (keyword === null) return;
                //lowercase keyword
                keyword = keyword.toLowerCase();
                if (selectedKeywords.includes(keyword)) {
                  keywordMatch = true;
                }
              });
            } catch (e) {
              console.log('ERROR! L271');
              console.log(e);
            }

            //if product and keyword match, render publication
            if (productMatch && keywordMatch) {
              renderRow(document, false);
            }
          });
        }

        resolve();
      });
    }

    function renderPublications() {
      return new Promise((resolve, reject) => {
        //render publications array using filters

        publicationData.forEach(publication => {
          let productMatch = false, keywordMatch = false;

          //check if publication matches selected product
          publication.associated_products.forEach(product => {
            if (product.name.toLowerCase() === selectedProduct) {
              productMatch = true;
            }
          });

          //check if publication keywords match selected keywords
          publication.keywords.forEach(keyword => {
            if (keyword === null) return;
            //lowercase keyword
            keyword = keyword.toLowerCase();
            if (selectedKeywords.includes(keyword)) {
              keywordMatch = true;
            }
          });

          //if product and keyword match, render publication
          if (productMatch && keywordMatch) {
            renderRow(publication, true);
          }
        });
        resolve();
      });
    }

    async function renderRow(data, isPublication) {
      //render row using template
      const container = document.querySelector(isPublication ? '[data-subj="pubs"]' : '[data-subj="docs"]');
      const rowEl = document.createElement('div');

      const isProtected = () => {
        //if Veeva doc, get protected state
        if (isPublication) return null;

        if (data.protected__c === true) return 'data-status="locked"'; else return 'data-status="unlocked"';
      }

      const productName = () => {
        //get product name
        if (isPublication) return data.associated_products[0].name.toUpperCase(); else {
          let productName = null;
          productData.forEach(product => {
            if (product.veeva_id === data.product__v[0]) {
              productName = product.name;
            }
          });
          return productName.toUpperCase();
        }
      }

      const authors = () => {
        //if authors list is more than 3, show "et al."
        if (data.authors.length > 3) {
          return `${data.authors[0]}, ${data.authors[1]}, ${data.authors[2]}, et al.`;
        } else {
          return data.authors.join(", ");
        }
      }

      rowEl.innerHTML = `
        <div class="card mb-4" ${isProtected()}>
          <div class="card-body d-md-flex">
            <div class="align-items-center col-12 col-md-9 col-lg-10">
              <h1>${productName()}<sup>&reg;</sup></h1>
              <h2>${isPublication ? data.title : data.name__v}</h2>
              ${isPublication ? `<h3>${new Date(data.publication_date).getFullYear()}</h3>` : ''}
              ${isPublication ? `<h4>${authors()}</h4>` : ''}
            </div>
            <div class="d-md-flex align-items-center col-12 col-md-3 col-lg-2">
              <a target="_blank" href="">
                <button class="btn" type="button" data-action="view">
                  <span>View</span>
                </button>
              </a>
            </div>
          </div>
        </div>
      `;

      if (isPublication) {
        //add link to a tag
        rowEl.querySelector('a').setAttribute('href', data.url);
      } else {
        //add event listener to a tag
        rowEl.querySelector('a').addEventListener('click', e => {
          e.preventDefault();
          if (data.protected__c === true) {
            const npiNumber = sessionStorage.getItem('npiNumber');
            //if protected, show modal and set locked view
            if (npiNumber === null) {
              showNPIModal(data);
            } else {
              //download file

          //fetch(`/api/mira/v1/download-srl/veeva_doc_id=${data.id}/npi=${npiNumber}`)
            fetch(`/api/mira/v1/download-srl/veeva_doc_id=${data.id}/npi=${npiNumber}/v_major=${data.major_version_number__v}/v_minor=${data.minor_version_number__v}`)
                .then(response => response.blob())
                .then(blob => {
                  if (blob.size === 0) {
                    showNPIModal(data);
                    return;
                  }
                  const downloadUrl = URL.createObjectURL(blob);
                  const a = document.createElement("a");
                  a.href = downloadUrl;
                  a.download = data.filename__v;
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                  logSRLClick(data.veeva_id__v, npiNumber, data.document_number__v, data.name__v);
                }).catch(e => {
                //if error, show error message

              })
            }
          } else{
            //console.log('doc is unprotected');
            // download unprotected file
            fetch(`/api/mira/v1/download-srl/veeva_doc_id=${data.id}`)
            .then(response => response.blob())
            .then(blob => {
              if (blob.size === 0) {
                throw new Error('Failed to download document');
              }
              const downloadUrl = URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = downloadUrl;
              a.download = data.filename__v;
              console.log('data.filename__v: ' + data.filename__v);
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              const npiNumber  = (sessionStorage.getItem('npiNumber')) ?  "0" : sessionStorage.getItem('npiNumber');
              logSRLClick(data.veeva_id__v, npiNumber, data.document_number__v, data.name__v);
            }).catch(e => {
            //if error, show error message
              console.log('Failed to download document');
              //console.log(e);
          })
          }
        });
      }
      container.appendChild(rowEl);
    }

    function checkEmptyResults() {
      //check if there are no results
      setTimeout(() => {
        const pgsCount = document.querySelector('[data-obj="pgs-count"]') || '0';
        const docCount = document.querySelector('[data-obj="doc-count"]');
        const pubCount = document.querySelector('[data-obj="pub-count"]');
        console.log('pgsCount.innerHTML = ' + pgsCount.innerHTML);
        if ((!pgsCount.innerHTML || pgsCount.innerHTML === "0") && docCount.innerHTML === "0" && pubCount.innerHTML === "0") {
          //show no results message and hide results
          document.querySelector('[data-widget="prod-no-results"]').setAttribute('style', 'display: block !important');
          document.querySelector('[data-widget="product-results"][data-subj="results"]').style.display = 'none';
        } else {
          //show results
          document.querySelector('[data-widget="prod-no-results"]').style.display = 'none';
          document.querySelector('[data-widget="product-results"][data-subj="results"]').style.display = 'block';
        }
      }, 500);
    }

    function showNPIModal(data) {
      const modal = document.querySelector('[data-widget="modal-npi"]');
      modal.style.display = 'block';
      modal.querySelector('[data-status]').setAttribute('data-status', 'locked');

      modal.querySelector('#button-npi').setAttribute('data-doc-id', data.id);
      modal.querySelector('#button-npi').setAttribute('data-doc-number', data.document_number__v);
      modal.querySelector('#button-npi').setAttribute('data-filename', data.filename__v);
      modal.querySelector('#button-npi').setAttribute('data-doc-title', data.name__v);
      modal.querySelector('#button-npi').setAttribute('data-v-major', data.major_version_number__v);
      modal.querySelector('#button-npi').setAttribute('data-v-minor', data.minor_version_number__v);
    }

    function logSRLClick(veevaId, npi, docId, docTitle) {
      //log SRL click
      fetch(`/api/mira/v1/log/requested-srl`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }, body: JSON.stringify({
          veeva_id: veevaId, npi: npi, document_number: docId, document_title: docTitle
        })
      })
        .then(response => response.text())
        .then(data => {
          console.log(data);
        })
        .catch(e => {
          console.log(e);
        })
    }
  }
};

export default SearchResults
